import { styled } from "styled-components";

const BlockTitle = styled.p`
  font-weight: bold;
  position: relative;
  z-index: 2;
`;

export default BlockTitle;
